import {CSSProperties} from 'react';

export function hasRTL(text?: string) {
	return text?.match(/^[0-9,:; ]*?[\u0590-\u05ff\u0600-\u06ff]/);
}

export function resolveDirectionStyleRTL(text?: string, style?: CSSProperties): CSSProperties {
	return {width: '100%', direction: hasRTL(text) ? 'rtl' : 'unset', ...style};
}
